import {
  BellRing,
  Calendar,
  CalendarClock,
  Factory,
  Mail,
  Package,
  Receipt,
  Settings,
  Users,
  type LucideIcon,
} from 'lucide-react';

export const HELP_CENTER_CATEGORIES = [
  'calendar',
  'online-bookings',
  'sales',
  'crm',
  'b2b-orders',
  'production-orders',
  'settings',
  'system-notifications',
  'bride-notifications',
] as const;

export type HelpCenterCategory = (typeof HELP_CENTER_CATEGORIES)[number];

export const HELP_CENTER_CATEGORY_ICONS: Record<HelpCenterCategory, LucideIcon> = {
  calendar: Calendar,
  'online-bookings': CalendarClock,
  sales: Receipt,
  crm: Users,
  'b2b-orders': Package,
  'production-orders': Factory,
  settings: Settings,
  'system-notifications': BellRing,
  'bride-notifications': Mail,
};

export function isHelpCenterCategory(value: string): value is HelpCenterCategory {
  return (HELP_CENTER_CATEGORIES as readonly string[]).includes(value);
}
